import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-suitable',
  templateUrl: './suitable.component.html',
  styleUrls: ['./suitable.component.css']
})
export class SuitableComponent implements OnInit {
  definitionForm:FormGroup;
  submitted=false;
  constructor( 
      private formBuilder:FormBuilder,
      private activeModal:NgbActiveModal,) { }

  ngOnInit() {
     this.definitionForm=this.formBuilder.group({
      'suitable':[''],
     });
  }


   close(){
    this.activeModal.close();
  }


  save(){
    this.activeModal.close(  this.definitionForm.get("suitable").value);
  }
}
